class HozahConfig {
    
    apiUri() {
        return window.config.front.apiUri;
    }
}

const hozahConfig = new HozahConfig();

export default hozahConfig;